const Voting = function () {
    document.querySelectorAll('.c-was-this-helpful > button').forEach(button => {
        button.addEventListener('click', function (e) {
            const clickedButton = e.target.classList.contains('thumbs-up') ? 'Thumbs Up' : 'Thumbs Down';
            const pageURL = window.location.href;

            let postTitle = document.querySelector('h1').innerText || document.title;
            let eventCategory = '';

            console.log('Clicked Button: ' + clickedButton);
            console.log('Post Title: ' + postTitle);
            console.log('Page URL: ' + pageURL);

            // Push event to dataLayer
            window.dataLayer = window.dataLayer || [];

            if (pageURL.includes('partner-toolkit')) {
                eventCategory = 'Partner Toolkit Feedback';

                if (e.target.classList.contains('share-facts')) {
                    postTitle = button.parentElement.parentElement.querySelector('.wp-block-file__button').innerText;
                } else if (e.target.classList.contains('campaign-card') || e.target.classList.contains('newsletter')) {
                    postTitle = button.parentElement.parentElement.querySelector('.wp-block-heading').innerText;
                } else {
                    postTitle = button.parentElement.parentElement.parentElement.querySelector('.wp-block-heading').innerText;
                }
            } else {
                eventCategory = 'Article Feedback';
            }

            const eventData = {
                event: 'Thumbs Feedback',
                event_category: eventCategory,
                event_label: `${clickedButton}, ${postTitle}`,
                value: clickedButton === 'Thumbs Up' ? 1 : -1,
            };

            window.dataLayer.push(eventData);

            // Log confirmation for development.
            console.log('Event pushed to dataLayer:', eventData);

            // Change text to "Thanks for your vote!"
            const helpfulContainer = e.target.closest('.c-was-this-helpful');
            if (helpfulContainer) {
                const textElement = helpfulContainer.querySelector('p');
                if (textElement) {
                    textElement.textContent = 'Thanks for your vote!';
                }
            }

            // Disable buttons
            helpfulContainer.querySelectorAll('button').forEach(btn => {
                btn.disabled = true;
                btn.classList.add('disabled');
            });
        });
    });
}
export default Voting;